import appSettingsReducer from './appSettings'
import basisTypesSettingsReducer from './basisTypesSettings'
import calendarSettingsReducer from './calendarSettings'
import checkoutSettingsReducer from './checkoutSettings'
import customerDetailsReducer from './customerDetails'
import detailsSettingsReducer from './detailsSettings'

const reducer = {
    appSettings: appSettingsReducer,
    basisTypesSettings: basisTypesSettingsReducer,
    calendarSettings: calendarSettingsReducer,
    checkoutSettings: checkoutSettingsReducer,
    customerDetails: customerDetailsReducer,
    detailsSettings: detailsSettingsReducer,
}

export default reducer
